import { useTranslation } from 'next-i18next';
import Icon from '@/components/common/iconedLinks/Icon';
import { URLS } from '@/constants/urls';
import { useAppDispatch } from '@/redux';
import { startAssistantConversation } from '@/redux/slices/assistant.slice';
import styles from './virtual-assistant-shortcut.module.scss';

export const VirtualAssistantShortcut = ({ withLabel = false }) => {
	const t = useTranslation('alter').t;
	const tCommon = useTranslation('common').t;

	const dispatch = useAppDispatch();

	return (
		<div className={styles.container} onClick={() => dispatch(startAssistantConversation(undefined))}>
			<div className={styles['virtual-assistant-shortcut']}>
				<Icon src={URLS.SPARKLES_STARS_PURPLE} alt={t('icon')} height={16} width={16} />
			</div>
			{withLabel && <p>{tCommon('assistant.shortcut')}</p>}
		</div>
	);
};
